import qs from 'qs';
import { axios, path } from './config';

export function outboundAriConfig({ threadId }) {
  const params = {};

  if (threadId) {
    params.thread_id = threadId;
  }

  return axios.get(path.OUTBOUND_ARI, { params });
}

export function enableAri({ threadId, candidateId, sequenceId, text, initialMessageOverride }) {
  const params = {
    thread_id: threadId,
    candidate_id: candidateId,
    sequence_id: sequenceId,
    mark_read: true,
  };

  if (text) {
    params.text = text;
  }
  if (initialMessageOverride) {
    params.initial_message_override = true;
  }

  return axios.post(path.ENABLE_ARI + qs.stringify(params));
}

export function disableAri({ threadId }) {
  return axios.post(path.DISABLE_ARI + qs.stringify({ thread_id: threadId }));
}

export function getSequence({ id }) {
  return axios.get(path.GET_SEQUENCES, { params: { id } });
}

export function getSequenceTypes() {
  return axios.get(path.SEQUENCE_TYPES);
}
